import React from "react";
import ContentLoader from "react-content-loader";

const Loader = (props) => {
	const height = "125";
	const width = window.innerWidth;

	return (
		<ContentLoader
			viewBox={`0 0 ${width} ${height}`}
			height={height}
			width={width}
			speed={1.5}
			{...props}>
			<rect x="20" y="20" rx="5" ry="5" width="96" height="96" />
			<rect
				x="145"
				y="20"
				rx="5"
				ry="5"
				width={width - width / 4}
				height="12"
			/>
			<rect
				x="145"
				y="40"
				rx="5"
				ry="5"
				width={width - width / 3}
				height="12"
			/>
			<rect
				x="145"
				y="60"
				rx="5"
				ry="5"
				width={width - width / 2}
				height="12"
			/>
		</ContentLoader>
	);
};

const SearchLoader = (props) => (
	<>
		<ContentLoader height={40}>
			<rect x="0" y="0" rx="5" ry="5" width="500" height="40" />
		</ContentLoader>

		{Array(5)
			.fill("")
			.map((e, i) => (
				<Loader
					key={i}
					style={{ opacity: Number(2 / i).toFixed(1) }}
					{...props}
				/>
			))}
	</>
);

export default SearchLoader;
